import { Card } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Badges } from '../cards-filter/Badges';

const EventCard = ({
  title,
  previewImage,
  previewText,
  dateString,
  url,
  badgeText,
  badges,
}) => (
  <Card className="h-100 overflow-hidden card-badge__container">
    <a href={url} className="d-block image-hover">
      <Card.Img
        variant="top"
        src={previewImage.url}
        width={previewImage.width}
        height={previewImage.height}
        alt={previewImage.alt}
      />
    </a>
    <Card.Body className="space-y-2">
      <h2 className="h3">{title}</h2>
      <div>
        <i className="fas fa-calendar-alt text-primary icon__before-text" />
        {dateString}
      </div>
      <div>{parse(previewText)}</div>
    </Card.Body>
    <Card.Footer className="bg-white border-top-0">
      <a className="btn btn-outline-primary" href={url}>
        Find out more
      </a>
    </Card.Footer>
    {!isEmpty(badges) && <Badges badges={badges} />}
    {isEmpty(badges) && badgeText && (
      <div className="card-badge__badge">{badgeText}</div>
    )}
  </Card>
);

export default EventCard;

EventCard.propTypes = {
  title: PropTypes.string.isRequired,
  previewImage: PropTypes.shape({
    url: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    alt: PropTypes.string,
  }),
  previewText: PropTypes.string.isRequired,
  dateString: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  badgeText: PropTypes.string,
  badges: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      badgeIcon: PropTypes.string,
      badgeColour: PropTypes.string,
      badgeTextColour: PropTypes.string,
    })
  ),
};
